import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
} from "reactstrap";
import {FaCopy } from "react-icons/fa";
import SuperAdminNavbar from "../Components/Superadminnavbar";
import { useDataContext } from "../Context/dataContext";
import { NotFound } from "./NotFound";
import { toast, ToastContainer } from "react-toastify";

function UsersAdmins() {
  // Estado de los administradores
  const { url, infoTkn } = useDataContext();
  const [admin, setAdmin] = useState({});
  const [admins, setAdmins] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredUsuarios = admins.filter((user) => {
    const fullName = `${user.adm_name} ${user.adm_lastname}`.toLowerCase();
    return fullName.includes(searchQuery.toLowerCase());
  });

  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [ordersByUser, setOrdersByUser] = useState([]);

  const fetchDataSadmin = useCallback(async () => {
    try {
      const response = await axios.get(
        `${url}/Auth/findByJWTSuperAdmin/${infoTkn}`,
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );
      setAdmin(response.data.data);

      const responseAdmins = await axios.get(`${url}/Admin`, {
        headers: {
          Authorization: `Bearer ${infoTkn}`,
        },
      });
      setAdmins(responseAdmins.data);
    } catch (error) {
      console.log(error);
    }
  }, [infoTkn, setAdmin, url]);

  const fetchUsersByAdmin = useCallback(
    async (e) => {
      try {
        const response = await axios.get(`${url}/Admin/${e}`, {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        });
        setUsers(response.data.User);

        setDetailsModalOpen(false);
        setClientsModalOpen(true);
      } catch (error) {
        console.error(error);
      }
    },
    [infoTkn, setUsers, url]
  );

  const fetchOrdersByUser = useCallback(
    async (e) => {
      try {
        const response = await axios.get(`${url}/Movements/user/${e}`, {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        });
        setOrdersByUser(response.data);

        setClientsModalOpen(false);
        setTransactionsModalOpen(true);
      } catch (error) {
        console.error(error);
      }
    },
    [infoTkn, setOrdersByUser, url]
  );

  const fetchOrdersByAdmin = useCallback(
    async (e) => {
      try {
        const response = await axios.get(`${url}/Movements/admin/${e}`, {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        });
        setOrders(response.data);

        setDetailsModalOpen(false);
        setTransactionsModalOpenAdm(true);
      } catch (error) {
        toast.error("No se encontraron movimientos para este administrador");
      }
    },
    [infoTkn, url]
  );

  const [adm_name, setAdmName] = useState("");
  const [adm_lastname, setAdmLastname] = useState("");
  const [adm_user, setAdmUser] = useState("");
  const [adm_email, setAdmEmail] = useState("");
  const [adm_wallet, setAdmWallet] = useState("");
  const [adm_porcent, setAdmPorcent] = useState(0);
  const [adm_password, setAdmPassword] = useState("");
  const [adm_confirmPassword, setAdmConfirmPassword] = useState("");
  const [adm_walletNetwork, setAdmWalletNetwork] = useState("");
  const [adm_formKYCToken, setAdmFormKYCToken] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [transactionsModalOpen, setTransactionsModalOpen] = useState(false);
  const [transactionsModalOpenAdm, setTransactionsModalOpenAdm] =
    useState(false);
  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const [receiptModalOpenBs, setReceiptModalOpenBs] = useState(false);
  const [movementsModalOpen, setMovementsModalOpen] = useState(false);
  const [newLogo, setNewLogo] = useState(null);

  // const [currentPage, setCurrentPage] = useState(1);
  // const adminsPerPage = 5; // Mostrar 5 administradores por página

  // // Calcular los administradores a mostrar en la página actual
  // const indexOfLastAdmin = currentPage * adminsPerPage;
  // const indexOfFirstAdmin = indexOfLastAdmin - adminsPerPage;
  // const currentAdmins = admins.slice(indexOfFirstAdmin, indexOfLastAdmin);

  // Función para cambiar de página
  // const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [clientsModalOpen, setClientsModalOpen] = useState(false);

  const [selectedAdmin, setSelectedAdmin] = useState(null);

  // Función para abrir el modal de detalles
  const handleViewDetails = (admin) => {
    setSelectedAdmin(admin);
    setDetailsModalOpen(true);
  };

  // Función para abrir el modal de edición
  const handleEditAdmin = () => {
    setAdmName(selectedAdmin.adm_name);
    setAdmUser(selectedAdmin.adm_user);
    setAdmEmail(selectedAdmin.adm_email);
    setAdmWallet(selectedAdmin.adm_wallet);
    setAdmPorcent(selectedAdmin.adm_porcent * 100);

    setDetailsModalOpen(false);
    setEditModalOpen(true);
  };

  // Abrir modal con el comprobante
  const handleViewReceipt = (transaction) => {
    setSelectedTransaction(transaction);
    setTransactionsModalOpen(false);
    setReceiptModalOpen(true);
  };

  const handleViewReceiptEur = (transaction) => {
    setSelectedTransaction(transaction);
    setTransactionsModalOpen(false);
    setReceiptModalOpenBs(true);
  };

  const handleImageChange = (e) => {
    setNewLogo(e.target.files[0]);
  };

  const handleAggAdmin = async () => {
    try {
      if (selectedAdmin) {
        await axios.put(
          `${url}/Admin/${selectedAdmin.adm_id}`,
          {
            adm_name: adm_name,
            adm_user: adm_user,
            adm_email: adm_email,
            adm_wallet: adm_wallet,
            adm_porcent: adm_porcent / 100,
          },
          {
            headers: {
              Authorization: `Bearer ${infoTkn}`,
            },
          }
        );

        if (newLogo) {
          const formData = new FormData();
          formData.append("adm_logo", newLogo);
  
          await axios.put(`${url}/Admin/logo/${selectedAdmin.adm_id}`, formData, {
            headers: { Authorization: `Bearer ${infoTkn}`, "Content-Type": "multipart/form-data" },
          });
        }

        setSelectedAdmin(null);
        setEditModalOpen(false);
        window.location.reload();
      } else {
        await axios.post(
          `${url}/Auth/registerAdmin`,
          {
            adm_name: adm_name,
            adm_lastname: adm_lastname,
            adm_user: adm_user,
            adm_email: adm_email,
            adm_wallet: adm_wallet,
            adm_status: "active",
            adm_porcent: adm_porcent / 100,
            adm_password: adm_password,
            adm_logo: 'Logo',
            adm_walletNetwork: adm_walletNetwork,
            adm_formKYCToken: adm_formKYCToken,
          },
          {
            headers: {
              Authorization: `Bearer ${infoTkn}`,
            },
          }
        );
        setModalOpen(false);

        await axios.post(`${url}/Mailer/EmailWelcome/${adm_email}`);

        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleStatusChange = async (user) => {
    try {
      await axios.put(
        `${url}/Users/${user.use_id}`,
        {
          use_verif: user.use_verif === "S" ? "N" : "S",
        },
        {
          headers: {
            Authorization: `Bearer ${infoTkn}`,
          },
        }
      );

      fetchUsersByAdmin(selectedAdmin?.adm_id);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataSadmin();
  }, [fetchDataSadmin]);

  return admin ? (
    <div>
      <SuperAdminNavbar />
      <div className="users-admin">
        <h2 className="titulo">Administradores Registrados</h2>

        <div className="barra-y-boton">
          {/* Barra de búsqueda */}
          <Input
            type="text"
            placeholder="Buscar Administrador"
            className="barra-busqueda"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          {/* Botón de agregar administrador */}
          <Button className="agregar-btn" onClick={() => setModalOpen(true)}>
            Agregar Administrador
          </Button>
        </div>

        {/* Tabla de administradores */}
        <div className="tabla-container">
          <Table className="usuarios-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Agencia</th>
                <th>Correo</th>
                <th>Wallet Asignada</th>
                <th>Red</th>
                <th>Porcentaje</th>
                <th>Detalles</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsuarios.map((admin) => (
                <tr key={admin.adm_id}>
                  <td>
                    {admin.adm_name} {admin.adm_lastname}
                  </td>
                  <td>{admin.adm_user}</td>
                  <td>{admin.adm_email}</td>
                  <td>{admin.adm_wallet}</td>
                  <td>{admin.adm_walletNetwork}</td>  
                  <td>{admin.adm_porcent * 100}%</td>
                  <td>
                    <Button
                      className="detalles-btn"
                      onClick={() => handleViewDetails(admin)}
                    >
                      Ver Detalles
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Paginación */}
      {/* <div className="paginacion">
        {Array.from(
          { length: Math.ceil(admins.length / adminsPerPage) },
          (_, index) => (
            <Button
              key={index + 1}
              className={`pagina-btn ${
                currentPage === index + 1 ? "active" : ""
              }`}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Button>
          )
        )}
      </div> */}

      <Modal
        isOpen={detailsModalOpen}
        toggle={() => setDetailsModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setDetailsModalOpen(false)}>
          Detalles del Administrador
        </ModalHeader>
        <ModalBody>
          <p>
            <strong>Nombre:</strong> {selectedAdmin?.adm_name}
          </p>
          <p>
            <strong>Agencia:</strong> {selectedAdmin?.adm_user}
          </p>
          <p>
  <strong>Wallet:</strong>{" "}
  <span className="wallet-text">
    {selectedAdmin?.adm_wallet
      ? `${selectedAdmin.adm_wallet.slice(0, 6)}...${selectedAdmin.adm_wallet.slice(-4)}`
      : "No disponible"}
  </span>
  {selectedAdmin?.adm_wallet && (
    <button
      className="copy-btn"
      onClick={() => {
        navigator.clipboard.writeText(selectedAdmin.adm_wallet);
        toast.success("Wallet copiada al portapapeles");
      }}
    >
      <FaCopy />
    </button>
  )}
</p>
          <p>
            <strong>Red:</strong> {selectedAdmin?.adm_walletNetwork}
          </p>
          <p>
            <strong>Tasa Objetiva:</strong> {selectedAdmin?.adm_porcent * 100}%
          </p>
          <p>
            <strong>Correo:</strong> {selectedAdmin?.adm_email}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="warning" onClick={handleEditAdmin}>
            Editar
          </Button>
          <Button
            color="primary"
            onClick={() => fetchUsersByAdmin(selectedAdmin?.adm_id)}
          >
            Ver Clientes
          </Button>
          <Button
            color="info"
            onClick={() => fetchOrdersByAdmin(selectedAdmin?.adm_id)}
          >
            Ver Movimientos
          </Button>{" "}
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={movementsModalOpen}
        toggle={() => setMovementsModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setMovementsModalOpen(false)}>
          Movimientos Financieros de {selectedAdmin?.name}
        </ModalHeader>
        <ModalBody>
          <table className="usuarios-table">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Monto (€)</th>
                <th>Destino</th>
                <th>Monto Convertido</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              {selectedAdmin?.movements?.map((movement, index) => (
                <tr key={index}>
                  <td>{movement.type}</td>
                  <td>€ {movement.euros}</td>
                  <td>{movement.destination}</td>
                  <td>{movement.convertedAmount}</td>
                  <td>{movement.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setMovementsModalOpen(false)}
          >
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal "Editar Administrador" */}
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setEditModalOpen(false)}>
          Editar Administrador
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nombre</Label>
            <Input
              type="text"
              value={adm_name}
              onChange={(e) => setAdmName(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Agencia</Label>
            <Input
              type="text"
              value={adm_user}
              onChange={(e) => setAdmUser(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Logo</Label>
            <Input type="file" id="newLogo" onChange={handleImageChange} accept="image/*" />
          </FormGroup>
          <FormGroup>
            <Label>Wallet</Label>
            <Input
              type="text"
              value={adm_wallet}
              onChange={(e) => setAdmWallet(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Tasa Objetiva</Label>
            <Input
              type="text"
              value={adm_porcent}
              onChange={(e) => setAdmPorcent(e.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label>Correo</Label>
            <Input
              type="email"
              value={adm_email}
              onChange={(e) => setAdmEmail(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancelar
          </Button>
          <Button color="success" onClick={handleAggAdmin}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal "Ver Clientes" */}
      <Modal
        isOpen={clientsModalOpen}
        toggle={() => setClientsModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setClientsModalOpen(false)}>
          Clientes de {selectedAdmin?.adm_name}
        </ModalHeader>
        <ModalBody>
          {users && users.length > 0 && (
            <Table className="usuarios-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>DNI</th>
                  <th>País</th>
                  <th>KYC</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {users.map((client) => (
                  <tr key={client.use_id}>
                    <td>{client.use_name}</td>
                    <td>{client.use_email}</td>
                    <td>{client.use_dni}</td>
                    <td>{client.use_country}</td>
                    <td>
                      <span className={`kyc-status ${client.use_verif}`}>
                        <Button
                          color={
                            client.use_verif === "S" ? "success" : "danger"
                          }
                          outline
                          onClick={() => handleStatusChange(client)}
                        >
                          {client.use_verif === "S"
                            ? "Verificado"
                            : "No verificado"}
                        </Button>
                      </span>
                    </td>
                    <td>
                      <Button
                        className="detalles-btn"
                        onClick={() => fetchOrdersByUser(client.use_id)}
                      >
                        Ver Detalles
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setClientsModalOpen(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal para agregar administrador */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} centered>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Agregar Administrador
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Nombre del Administrador</Label>
            <Input
              type="text"
              name="name"
              value={adm_name}
              onChange={(e) => setAdmName(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Apellido</Label>
            <Input
              type="text"
              name="name"
              value={adm_lastname}
              onChange={(e) => setAdmLastname(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Empresa</Label>
            <Input
              type="text"
              name="agency"
              value={adm_user}
              onChange={(e) => setAdmUser(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Red de Wallet</Label>
            <Input
              type="select"
              name="network"
              value={adm_walletNetwork}
              onChange={(e) => setAdmWalletNetwork(e.target.value)}
            >
              <option value="">Selecciona una red</option>
              <option value="Polygon">Polygon</option>
              <option value="Ethereum">Ethereum</option>
              <option value="Binance">Binance Smart Chain</option>
              <option value="Arbitrum">Arbitrum</option>
              <option value="Solana">Solana</option>
            </Input>
          </FormGroup>

          <FormGroup>
            <Label>Wallet</Label>
            <Input
              type="text"
              name="wallet"
              value={adm_wallet}
              onChange={(e) => setAdmWallet(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Porcentaje Objetivo</Label>
            <Input
              type="text"
              name="rate"
              value={adm_porcent}
              onChange={(e) => setAdmPorcent(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Correo Electrónico</Label>
            <Input
              type="email"
              name="email"
              value={adm_email}
              onChange={(e) => setAdmEmail(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Form KYC</Label>
            <Input
              type="text"
              name="kyc"
              value={adm_formKYCToken}
              onChange={(e) => setAdmFormKYCToken(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Contraseña Provisional</Label>
            <Input
              type="password"
              name="password"
              value={adm_password}
              onChange={(e) => setAdmPassword(e.target.value)}
            />
          </FormGroup>

          <FormGroup>
            <Label>Confirmar Contraseña Provisional</Label>
            <Input
              type="password"
              name="confirmPassword"
              value={adm_confirmPassword}
              onChange={(e) => setAdmConfirmPassword(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalOpen(false)}>
            Cancelar
          </Button>
          <Button
            color="success"
            onClick={handleAggAdmin}
            disabled={
              adm_name === "" ||
              adm_user === "" ||
              adm_email === "" ||
              adm_wallet === "" ||
              adm_porcent === "" ||
              adm_password === "" ||
              adm_confirmPassword === "" ||
              adm_walletNetwork === "" ||
              adm_formKYCToken === "" ||
              adm_password !== adm_confirmPassword
            }
          >
            Agregar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal "Ver Transacciones" */}
      <Modal
        isOpen={transactionsModalOpenAdm}
        toggle={() => setTransactionsModalOpenAdm(false)}
        centered
      >
        <ModalHeader toggle={() => setTransactionsModalOpenAdm(false)}>
          Transacciones
        </ModalHeader>
        <ModalBody>
          <Table className="usuarios-table">
            <thead>
              <tr>
                <th>Monto (€)</th>
                <th>Comrpbante (€)</th>
                <th>Moneda</th>
                <th>Monto Calculado</th>
                <th>Estado</th>
                <th>Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((transaction) => (
                <tr key={transaction.mov_id}>
                  <td>€ {transaction.mov_amount}</td>
                  <td>
                    <Button
                      className="comprobante-btn"
                      onClick={() => handleViewReceiptEur(transaction)}
                    >
                      📄 Ver
                    </Button>
                  </td>
                  <td>{transaction.mov_conversionType}</td>
                  <td>{transaction.mov_paymentAmount}</td>
                  <td>{transaction.mov_status}</td>
                  <td>
                    <Button
                      className="comprobante-btn"
                      onClick={() => handleViewReceipt(transaction)}
                    >
                      📄 Ver
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>

      {/* Modal "Ver Transacciones" */}
      <Modal isOpen={transactionsModalOpen} toggle={() => setTransactionsModalOpen(false)} centered>
  <ModalHeader toggle={() => setTransactionsModalOpen(false)}>
    Transacciones
  </ModalHeader>
  <ModalBody>
    <div className="modal-table-container">
      <Table className="usuarios-table">
        <thead>
          <tr>
            <th>Monto (€)</th>
            <th>Comprobante (€)</th>
            <th>Moneda</th>
            <th>Monto Calculado</th>
            <th>Estado</th>
            <th>Comprobante</th>
          </tr>
        </thead>
        <tbody>
          {ordersByUser.map((transaction) => (
            <tr key={transaction.mov_id}>
              <td>€ {transaction.mov_amount}</td>
              <td>
                <Button className="comprobante-btn" onClick={() => handleViewReceiptEur(transaction)}>
                  📄 Ver
                </Button>
              </td>
              <td>{transaction.mov_conversionType}</td>
              <td>{transaction.mov_paymentAmount}</td>
              <td>{transaction.mov_status}</td>
              <td>
                <Button className="comprobante-btn" onClick={() => handleViewReceipt(transaction)}>
                  📄 Ver
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </ModalBody>
</Modal>


      {/* Modal "Ver Comprobante" */}
      <Modal
        isOpen={receiptModalOpen}
        toggle={() => setReceiptModalOpen(false)}
        centered
      >
        <ModalHeader toggle={() => setReceiptModalOpen(false)}>
          Comprobante de Pago
        </ModalHeader>
        <ModalBody>
          {selectedTransaction?.mov_conversionType === "Usdt" ? (
            <p>
              <strong>Hash de Transacción:</strong>{" "}
              {selectedTransaction.mov_paymentProof}
            </p>
          ) : (
            <img
              src={`${url}/Movements/paymentProof/${selectedTransaction?.mov_paymentProof}`}
              alt="Comprobante"
              className="proof-image"
            />
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={receiptModalOpenBs}
        toggle={() => setReceiptModalOpenBs(false)}
        centered
      >
        <ModalHeader toggle={() => setReceiptModalOpenBs(false)}>
          Comprobante de Pago
        </ModalHeader>
        <ModalBody>
          <img
            src={`${url}/Movements/proof/${selectedTransaction?.mov_proof}`}
            alt="Comprobante"
            className="proof-image"
          />
        </ModalBody>
      </Modal>
      <ToastContainer />
    </div>
  ) : (
    <NotFound />
  );
}

export { UsersAdmins };
